<template>
  <div class="row">
    <div class="col-lg-12">
      <br />
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-4">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              GENERATE LABEL
                            </p>
                          </div>
                        </div>
                        <br />
                        <div
                          style="
                            height: 520px;
                            overflow: scroll;
                            overflow-x: hidden;
                          "
                          class="row"
                          v-for="(card, index) in qrs"
                          :key="index"
                        >
                          <div class="col-lg">
                            <div class="row" style="padding-bottom: 7px;">
                              <div class="col-lg">
                                <input
                                  style="border: 1px solid #5e99ff"
                                  type="checkbox"
                                  class="rounded-checkbox"
                                  id="checkbox"
                                  v-model="card.hazard"
                                  value="true"
                                />&nbsp;&nbsp;&nbsp;Contain Hazardous Substance?
                              </div>
                            </div>
                            
                            <div class="row">
                              <div class="col-lg">
                                <b-card
                                  class="card"
                                  border-variant="primary"
                                  header-bg-variant="primary"
                                  header-text-variant="white"
                                  style="
                                    box-shadow: 0px 0px;
                                    border: none;
                                    width: 95%;
                                    background-color: #f5f6fa;
                                  "
                                >
                                  <template #header>
                                    <h4 class="mb-0">
                                      OUTPUT - {{ index + 1 }}
                                    </h4>
                                  </template>
                                  <div style="background-color: #f5f6fa">
                                    <div class="row">
                                      <div class="col-lg">
                                        <p
                                          class=""
                                          style="color: #A5A5A5; font-weight: 600"
                                        >
                                          {{ card.wastetype }}
                                        </p>
                                      </div>
                                      <div class="col-lg-2 text-right">
                                        <base-button
                                          class="btn-link"
                                          @click="downloadQR(card, 'download')"
                                        >
                                          <i
                                            class="fa fa-download text-primary"
                                            aria-hidden="true"
                                          ></i>
                                        </base-button>
                                      </div>
                                      <div class="col-lg-2 text-right">
                                        <base-button
                                          class="btn-link"
                                          @click="downloadQR(card, 'print')"
                                        >
                                          <i
                                            class="fa fa-print text-primary"
                                            aria-hidden="true"
                                          ></i>
                                        </base-button>
                                      </div>
                                    </div>
                                  </div>
                                </b-card>
                              </div>
                              <br />
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg text-right">
                      <base-button
                        wide
                        type="danger"
                        @click.native="back()"
                        class="btn-previous"
                      >
                        BACK
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal :show.sync="modals.done" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>PRE-PROCESSING COMPLETED</h1>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import { Modal, ImageUpload } from "@/components";
import { Select, Option } from "element-ui";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import moment from "moment";

export default {
  name: "JobPage1",
  components: {
    BCard,
    Modal,

    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      outputs: [
        {
          id: 0,
          quantityProduced: "",
          outputType: "",
        },
      ],
      qrs: [
        {
          qrid: 0,
          wastetype: "Recon Oil",
          refno: "NVJ456455248",
          hazard: false,
        },
        {
          qrid: 0,
          wastetype: "Water",
          refno: "NVJ456455248",
          hazard: false,
        },
      ],
      preprocessingrefno: "",
      quantitytobeprocessed: "",
      wasteline: "",
      wastelines: [
        {
          label: "waste line A",
          value: "waste line A",
        },
        {
          label: "waste line B",
          value: "waste line B",
        },
      ],
      viewflag: "qr",
      modals: {
        done: false,
      },
      tajuk: "hehasdksdksade",
      selectedFileName: "",
      allfilename: [],

      selectedOption: "option1",
      jobreferenceno: "",
      companyname: "",
      operationtype: "",
      companyaddress: "",
      phoneno: "",
      faxno: "",

      wastegeneration: "",
      landweightin: "",
      vesselweightin: "",
      weightout: "",
      landnetweight: "",
      vesselnetweight: "",
      landweightreceipt: "",
      vesselweightreceipt: "",

      cards: [],
      wastes: [{}],
      wastesvessel: [{}],

      // wastevehicleno: [],
      // wasteic: [],

      cardWasteVesselCount: 0,
      cardWasteCount: 0,

      //dalam card land
      wastecode: [],
      solidwastetype: [],
      landphreading: [],
      landtemperature: [],
      landwasteline: [],
      landhandlingmethod: [],
      landwastelocationstatus: [],

      //dalam card vessel
      wastetype: [],
      vesselphreading: [],
      vesseltemperature: [],
      vesselwasteline: [],
      vesselhandlingmethod: [],
      vesselwastelocationstatus: [],

      selects: {
        wasteline: "",
        wastelines: [
          { value: 1, label: "Line A - Liquid Mixture" },
          { value: 2, label: "Line B - Slurry Liquid" },
          { value: 3, label: "Line C - Aqueous Waste" },
        ],

        handlingmethod: "",
        handlingmethods: [
          { value: 1, label: "Landfill Dump" },
          { value: 2, label: "Recycling" },
          { value: 3, label: "Waste to Energy" },
          { value: 4, label: "Composting" },
          { value: 5, label: "Thermal Treatment" },
        ],
        wastelocationstatus: "",
        wastelocationstatuss: [
          { value: 1, label: "In PRF" },
          { value: 2, label: "Disposed to Prescribed Premise" },
        ],
      },

      docs: "",
      document: 0,

      documentID: [],
    };
  },
  created() {
    console.log(this.$route.params.refnum);
    this.getDetails(this.$route.params.refnum);
  },
  methods: {
    downloadQR(data, flag) {
      console.log(data);

      let doc = jsPDF("p", "mm", "a4");

      if (Boolean(data.hazard) == true) {
        var img = new Image();
        img.src = require("@/assets/img/Skull toxic.png");
        doc.addImage(img, "JPEG", 55, 15, 100, 100);

        doc.setTextColor(104, 104, 104);
        doc.text("SW / Annex Code", doc.internal.pageSize.getWidth() / 2, 130, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.wastetypecode,
          doc.internal.pageSize.getWidth() / 2,
          140,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text("Date Created", doc.internal.pageSize.getWidth() / 2, 160, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          moment(data.datecreated).format("YYYY-MM-DD"),
          doc.internal.pageSize.getWidth() / 2,
          170,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        console.log(doc.internal.pageSize.getWidth() / 2)
        doc.text("Waste Generator", doc.internal.pageSize.getWidth() / 2, 190, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.wastegenerator,
          doc.internal.pageSize.getWidth() / 2,
          200,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text("Company Address", doc.internal.pageSize.getWidth() / 2, 220, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.companyaddress,
          doc.internal.pageSize.getWidth() / 2,
          230,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text(
          "Phone No. / Fax No.",
          doc.internal.pageSize.getWidth() / 2,
          250,
          {
            align: "center",
          }
        );
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.phoneno + " / " + data.faxnumber,
          doc.internal.pageSize.getWidth() / 2,
          260,
          {
            align: "center",
          }
        );
      }

      if (Boolean(data.hazard) == false) {
        doc.setTextColor(104, 104, 104);
        doc.text("SW / Annex Code", doc.internal.pageSize.getWidth() / 2, 20, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(data.wastetype, doc.internal.pageSize.getWidth() / 2, 30, {
          align: "center",
        });

        doc.setTextColor(104, 104, 104);
        doc.text("Date Created", doc.internal.pageSize.getWidth() / 2, 50, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          moment(data.datecreated).format("YYYY-MM-DD"),
          doc.internal.pageSize.getWidth() / 2,
          60,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text("Waste Generator", doc.internal.pageSize.getWidth() / 2, 80, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.wastegenerator,
          doc.internal.pageSize.getWidth() / 2,
          90,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text("Company Address", doc.internal.pageSize.getWidth() / 2, 110, {
          align: "center",
        });
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.companyaddress,
          doc.internal.pageSize.getWidth() / 2,
          120,
          {
            align: "center",
          }
        );

        doc.setTextColor(104, 104, 104);
        doc.text(
          "Phone No. / Fax No.",
          doc.internal.pageSize.getWidth() / 2,
          140,
          {
            align: "center",
          }
        );
        doc.setTextColor(66, 62, 62);
        doc.text(
          data.phoneno + " / " + data.faxnumber,
          doc.internal.pageSize.getWidth() / 2,
          150,
          {
            align: "center",
          }
        );
      }

      if (flag == "download") {
        doc.save(`Label.pdf`);
      }

      if (flag == "print") {
        window.open(doc.output("bloburl"), "_blank");
      }
    },
    getDetails(refno) {
      this.qrs = [];
      this.$http.get(":10001/api/v1/incoming/" + refno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.waste_detail.length; i++) {
            let obj = {
              qrid: i + 1,
              wastetype: response.waste_detail[i].waste_code,
              wastetypecode: response.waste_detail[i].waste_code,
              refno: refno,
              hazard: false,
              flag: "incoming",
              datecreated: response.quotation.created_at,
              wastegenerator: response.company.company_name,
              companyaddress: response.company.company_address,
              phoneno: response.company.company_phone_number,
              faxnumber:
                response.company.company_fax_number == ""
                  ? "N/A"
                  : response.company.company_fax_number,
            };
            this.qrs.push(obj);
          }
        }
      });
    },
    download() {
      console.log("download");
    },
    print() {
      console.log("print");
    },
    addOutput() {
      this.outputs.push({
        id: this.outputs.length + 1,
        quantityProduced: "",
        outputType: "",
      });
    },
    // using
    back() {
      this.$router.push("/Incoming");
    },
    done(flag) {
      if (flag == "output") {
        console.log(flag);
        this.viewflag = "qr";
      }

      if (flag == "create") {
        this.modals.done = true;
      }
    },
    getNext() {
      this.$router.push("/JobPage2");
    },
    // saveDraft() {
    //   console.log("save draft");
    // },
    onFileChange(event) {
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;

      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.$http
            .post(":10001/api/v1/upload/", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("data masuk", response);
                this.documentID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            });
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },

    //land waste
    addWaste() {
      this.cardWasteCount++;
      this.wastes.push({ id: this.cardWasteCount });
    },
    getWasteTitle(index) {
      return `Waste - ${index + 1}`;
    },
    deleteWaste(index) {
      this.wastes.splice(index, 1);
    },
    deleteWasteById(wasteId, index) {
      const foundIndex = this.wastes.findIndex((waste) => waste.id === wasteId);
      if (foundIndex !== -1) {
        this.wastes.splice(foundIndex, 1);
        this.landphreading.splice(foundIndex, 1);
        this.landtemperature.splice(foundIndex, 1);
      } else {
        console.log("Vehicle not found with ID: ", wasteId);
      }
    },

    //vessel
    addWasteVessel() {
      this.cardWasteVesselCount++;
      this.wastesvessel.push({ id: this.cardWasteVesselCount });
    },
    getWasteVesselTitle(index) {
      return `Waste - ${index + 1}`;
    },
    deleteWasteVessel(index) {
      this.wastesvessel.splice(index, 1);
    },
    deleteWasteVesselById(wasteVesselId, index) {
      const foundIndex = this.wastesvessel.findIndex(
        (wastevessel) => wastevessel.id === wasteVesselId
      );
      if (foundIndex !== -1) {
        this.wastesvessel.splice(foundIndex, 1);
        this.vesselphreading.splice(foundIndex, 1);
        this.vesseltemperature.splice(foundIndex, 1);
      } else {
        console.log("Vehicle not found with ID: ", wasteVesselId);
      }
    },

    //vessel waste
  },

  computed: {
    checkNo: {
      get() {
        return this.faxno.startsWith("0") || this.faxno.startsWith("+")
          ? this.phoneno
          : this.faxno;
      },
      set(value) {
        if (value.startsWith("0")) {
          this.phoneno = value;
          this.faxno = "";
        } else {
          this.faxno = value;
          this.phoneno = "";
        }
      },
    },
  },
};
</script>
<style>
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
.scrollable {
  height: 600px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}
.card .card-header {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 18px;
}
.custom-dropdown .el-select-dropdown {
  /* Dropdown styles */
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-option {
  /* Option styles */
  color: #333;
  background-color: #fff;
}
.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px; /* Adjust as needed */
}
.scrollable-content {
  flex: 0 0 auto;
  white-space: nowrap;
  margin-right: 15px; /* Adjust as needed */
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
